import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

// MAX-3878 — Move to Category modal.
export const styles = (theme: Theme) => ({
	actions: {
		padding: "16px 24px",
	},
	body: {
		marginBottom: 16,
	},
} satisfies Record<string, CSSObject>);
